import React from 'react';

const ProductBadges = ({ isOffer, discount, quantity, isLowStock }) => {
  const hasDiscount = discount > 0;

  return (
    <div className="absolute top-2 left-2 flex flex-col gap-1.5">
      {isOffer && (
        <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
          Special Offer
        </span>
      )}
      {hasDiscount && (
        <span className="bg-green-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
          {discount}% OFF
        </span>
      )}
      {isLowStock && (
        <span className="bg-orange-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
          Only {quantity} left!
        </span>
      )}
    </div>
  );
};

export default ProductBadges;
